export default __webpack_public_path__ + "static/media/masum.b29467c4.png";